export default "__VITE_ASSET__BHimmehg__"